import React, { useState } from 'react';
import PlansScreen, { Plan } from '../../../components/pwatv/PlansScreen';
import styles from './plansDemo.module.css';

const PlansDemo: React.FC = () => {
    const [selectedPlanId, setSelectedPlanId] = useState<string>('plan-90');

    const plans: Plan[] = [
        {
            id: 'plan-90',
            price: '₹549',
            originalPrice: '₹759',
            pricePerDay: '₹6.1/day',
            duration: 'for 90 days',
            isSelected: selectedPlanId === 'plan-90'
        },
        {
            id: 'plan-180',
            price: '₹999',
            originalPrice: '₹1499',
            pricePerDay: '₹5.5/day',
            duration: 'for 180 days',
            isSelected: selectedPlanId === 'plan-180'
        },
        {
            id: 'plan-365',
            price: '₹1799',
            originalPrice: '₹2699',
            pricePerDay: '₹4.9/day',
            duration: 'for 365 days',
            isSelected: selectedPlanId === 'plan-365'
        }
    ];

    const handlePlanSelect = (planId: string) => {
        setSelectedPlanId(planId);
        console.log('Selected plan:', planId);
    };

    return (
        <div className={styles.container}>
            <PlansScreen
                plans={plans}
                startDate="06/11/2025"
                endDate="07/11/2025"
                phoneNumber="+91 9899264235"
                onPlanSelect={handlePlanSelect}
            />
        </div>
    );
};

export default PlansDemo;

